import { createAction, props } from '@ngrx/store';

export const updateProjectDetails = createAction(
  '[Project] Update Project Details',
  props<{ formValue: any }>()
);

export const updateProjectEmitter = createAction(
  '[Project] Update project emitter',
  props<{ emitters: any }>()
);

export const resetProjectDetails = createAction('[Project] Reset Project Details');

export const resetProjectEmitter = createAction('[Project] Reset Project Emitter ');